document.addEventListener('DOMContentLoaded', function(){

    // get search collapse
    const searchCollapse = document.querySelector('#searchCollapse');

    // get search input
    const searchInput = searchCollapse?.querySelector('input[type="search"]');

    if ( !searchCollapse || !searchInput )
    {
        return;
    }

    // focus when shown
    searchCollapse.addEventListener('shown.bs.collapse', function(){
        // remove content of focusing field first
        // so the cursor is placed after the text content
        // otherwise it's placed to the beginning

        // save actual value and clear input
        let val = searchInput.value;

        searchInput.value = '';

        // place focus
        searchInput.focus();

        // place value back
        searchInput.value = val;
    });
    

});